export const MAX_POSITIONS_TOP_5_COM = [
  'krasnoyarsk',
  'kemerovo',
  'saratov',
  'irkutsk',
  'barnaul',
  'orenburg',
  'vladivostok',
  'hmao',
  'izhevsk',
  'habarovsk',
  'penza',
  'yaroslavl',
  'ulyanovsk',
  'cheboksary',
  'arhangelsk',
  'lipetsk',
  'ryazan',
  'kursk',
  'astrahan',
  'tambov',
  'novgorod',
];

export const MAX_POSITIONS_TOP_10_COM = [
  'msk',
  'spb',
  'krasnodar',
  'ekb',
  'rostov',
  'ufa',
  'kazan',
  'chelyabinsk',
  'nn',
  'samara',
  'novosibirsk',
  'stavropol',
  'perm',
  'volgograd',
  'krym',
  'omsk',
  'voronezh',
  'tyumen',
  'belgorod',
  'tula',
  'vladimir',
  'tver',
  'tomsk',
  'kaliningrad',
  'kaluga',
  'smolensk',
];

export const MAX_POSITIONS_TOP_10_ALL = [
  'mahachkala',
  'vladivostok',
  'izhevsk',
  'habarovsk',
  'kirov',
  'ulyanovsk',
  'bryansk',
  'vologda',
  'arhangelsk',
  'lipetsk',
  'kursk',
  'tomsk',
  'astrahan',
  'ulan-ude',
  'tambov',
  'ivanovo',
  'kurgan',
  'orel',
  'kostroma',
  'pskov',
];

export const MAX_POSITIONS_TOP_20_ALL = ['cheboksary', 'barnaul'];

export const MAX_POSITIONS_TOP_5_ALL = [
  'blagoveschensk',
  'birobidzhan',
  'chita',
  'nalchik',
  'petropavlovsk-kamchatskiy',
  'cherkessk',
  'magadan',
  'murmansk',
  'maykop',
  'gorno-altaysk',
  'nazran',
  'petrozavodsk',
  'syktyvkar',
  'yoshkar-ola',
  'saransk',
  'yakutsk',
  'vladikavkaz',
  'kyzyl',
  'abakan',
  'yuzhno-sahalinsk',
  'groznyy',
  'yanao',
];
